import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=e82ca2de&scoped=true&"
import script from "./NotificationPreview.vue?vue&type=script&lang=js&"
export * from "./NotificationPreview.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPreview.vue?vue&type=style&index=0&id=e82ca2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ca2de",
  null
  
)

export default component.exports